// @flow
import React from 'react';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import cx from 'classnames';
import Tooltip from 'react-tooltip';
import './BrandLikeButton.scss';

type Props = {
  likes: number,
  liked: boolean,
  disabled: boolean,
  onClick: () => void,
};

const BrandLikeButton = ({ likes, liked, onClick, disabled }: Props) => (
  <button
    className={cx('BrandLikeButton', { liked, disabled })}
    onClick={disabled ? undefined : onClick}
    {...(disabled ? { 'data-tip': '로그인 후 이용해주세요.' } : {})}
  >
    {liked ? <FaHeart /> : <FaRegHeart />}
    <div className="count">{likes ? likes.toLocaleString() : 0}</div>
    <Tooltip effect="solid" className="tooltip" />
  </button>
);
export default BrandLikeButton;



// WEBPACK FOOTER //
// ./src/components/brand/BrandLikeButton/BrandLikeButton.js